import { FluidSystemBase } from './base/fluid-system-base';

export class FluidSystem extends FluidSystemBase { }